"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseHelper = void 0;
const no_result_1 = require("../utilities/no-result");
class PromiseHelper {
    static timeout(timeout) {
        return new Promise((resolve, reject) => {
            try {
                setTimeout(() => {
                    resolve(no_result_1.NoResult.instance);
                }, timeout);
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
exports.PromiseHelper = PromiseHelper;
//# sourceMappingURL=promise-helper.js.map